export default __webpack_public_path__ + "static/media/filterIcon.da06d51e.svg";